import { TextField, Typography, Button, IconButton, Divider, Autocomplete, Snackbar } from '@mui/material'
import './LinesNewLine.css'
import { quoteLineType } from '../types'
import { ArrowForward } from '@mui/icons-material'
import { CurrencyInput } from '../helper'
import { manufacturerProviders } from '../lists'
import { useState } from 'react'
import axios from 'axios'

export function LinesNewLine(props: {
  open: number
  onClose: () => void
  lineItems: (quoteLineType & { children: quoteLineType[] })[]
  setLineItems: (lineItems: (quoteLineType & { children: quoteLineType[] })[]) => void
  quoteId: string
  bundle: string | null
}) {
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [newLineItem, setNewLineItem] = useState<Partial<quoteLineType>>({
    LineItemId: crypto.randomUUID(),
    LineNumber: props.open + 1,
    Bundle: props.bundle,
  })

  return (
    <div className="quote-new-line">
      <div className="quote-new-line-header">
        <Typography variant="h6">New Line Item</Typography>
        <IconButton onClick={() => props.onClose()}>
          <ArrowForward />
        </IconButton>
      </div>
      <Divider />
      <div className="quote-new-line-content">
        <TextField
          size="small"
          fullWidth
          label="Mfr Part #"
          value={newLineItem.MfrPartNumber}
          onChange={e => setNewLineItem({ ...newLineItem, MfrPartNumber: e.target.value })}
        />
        <TextField
          size="small"
          fullWidth
          multiline
          label="Description"
          value={newLineItem.Description}
          onChange={e => setNewLineItem({ ...newLineItem, Description: e.target.value })}
        />
        <div className="quote-new-line-content-double-row">
          <Autocomplete
            size="small"
            fullWidth
            options={manufacturerProviders}
            value={newLineItem.Provider}
            onChange={(_, value) => setNewLineItem({ ...newLineItem, Provider: value as string })}
            renderInput={params => <TextField {...params} label="Distributor" />}
          />
          <Autocomplete
            size="small"
            fullWidth
            options={manufacturerProviders}
            value={newLineItem.Manufacturer}
            onChange={(_, value) => setNewLineItem({ ...newLineItem, Manufacturer: value as string })}
            renderInput={params => <TextField {...params} label="Manufacturer" />}
          />
        </div>
        <div className="quote-new-line-content-quad-row">
          <CurrencyInput
            size="small"
            fullWidth
            label="Unit Cost"
            value={newLineItem.UnitCost ?? 0}
            onChange={value =>
              setNewLineItem({
                ...newLineItem,
                UnitCost: value ?? 0,
                ExtCost: (value ?? 0) * (newLineItem.Qty ?? 0),
              })
            }
          />
          <CurrencyInput
            size="small"
            fullWidth
            label="Unit Price"
            value={newLineItem.UnitPrice ?? 0}
            onChange={value => {
              const unitPrice = value ?? 0
              const unitCost = newLineItem.UnitCost ?? 0
              const totalFees = newLineItem.TotalFees ?? 0
              const creditCard = newLineItem.CreditCard ?? null
              const qty = newLineItem.Qty ?? 0

              const costWithFees = unitCost + totalFees + (creditCard ? unitCost * 0.03 : 0)
              const margin = unitPrice === 0 ? 0 : (1 - costWithFees / unitPrice) * 100

              setNewLineItem({
                ...newLineItem,
                UnitPrice: unitPrice,
                ExtPrice: unitPrice * qty,
                Margin: margin,
              })
            }}
          />
          <TextField
            size="small"
            fullWidth
            type="number"
            label="Qty"
            value={newLineItem.Qty ?? ''}
            onChange={e => {
              const qty = e.target.value === '' ? 0 : Number(e.target.value)
              setNewLineItem({
                ...newLineItem,
                Qty: e.target.value === '' ? undefined : qty,
                ExtPrice: (newLineItem.UnitPrice ?? 0) * qty,
                ExtCost: (newLineItem.UnitCost ?? 0) * qty,
              })
            }}
          />
          <CurrencyInput
            disabled
            size="small"
            fullWidth
            label="Ext Price"
            value={newLineItem.ExtPrice ?? 0}
            onChange={value => setNewLineItem({ ...newLineItem, ExtPrice: value ?? 0 })}
          />
        </div>
        <Button
          onClick={() => {
            const lineItemToSave = {
              ...newLineItem,
              ExtPrice: (newLineItem.UnitPrice ?? 0) * (newLineItem.Qty ?? 0),
              ExtCost: (newLineItem.UnitCost ?? 0) * (newLineItem.Qty ?? 0),
            }
            axios
              .post(`/newLineItem/${props.quoteId}`, { lineItem: lineItemToSave })
              .then(res => {
                props.setLineItems(res.data)
                props.onClose()
              })
              .catch(err => {
                console.error(err)
                setSnackbarOpen(true)
                setSnackbarMessage('Error adding line item')
              })
          }}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </div>
      <Snackbar
        autoHideDuration={5000}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
    </div>
  )
}
